import React, { useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import { isValidEmail, isValidPhone, isValidPhoneInput } from "../../../utils/AppUtils";
import { notificationService } from "../../../service/NotificationService";
import _ from "lodash";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import RoleSelect from "components/DropDowns/RoleSelect";

import { useTranslation } from "react-i18next";

function UserPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/users";
  const history = useHistory();
  const { id } = useParams();
  // Selects

  // Fields
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [fullName, setFullName] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [selectorDisabled, setSelectorDisabled] = useState(false);

  const [credits, setCredits] = useState(0);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [emailInput, setEmailInput] = useState("");

  const [invalidPhone, setInvalidPhone] = useState(false);
  const [selectedPhones, setSelectedPhones] = useState([]);
  const [phoneInput, setPhoneInput] = useState("");

  const [version, setVersion] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const getCommaSeparatedStringFromOptions = (options) => {
    if (options.length > 0) {
      return options.map((option) => option.value).join(",");
    }

    return null;
  };

  const save = () => {
    setIsDisabled(true);
    const user = {
      username: username ? username : undefined,
      password: password ? password : undefined,
      fullName: fullName ? fullName : null,
      credits: credits,
      roleId: roleId,
      emails: selectedEmails ? getCommaSeparatedStringFromOptions(selectedEmails) : null,
      phones: selectedPhones ? getCommaSeparatedStringFromOptions(selectedPhones) : null,
      version: version != null ? version + 1 : undefined,
    };

    if (password !== passwordRepeat) {
      const message = t("messages.passwordsDoNotMatch");
      notificationService.notifyWarn(message);
      setErrorMessage(message);
      setIsDisabled(false);
      return;
    }

    if (id) {
      apiService
        .putJson(`api/v1/users/${id}`, user)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.userSavedSuccessfully"));
          if (id !== apiService.getId()) history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/users", user)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.userCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  React.useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/users/${id}`)
      .then((user) => {
        fillFields(user);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
      });
  }, []);

  const fillFields = (user) => {
    setUsername(user.username);
    setFullName(user.fullName);

    if (user.credits) {
      setCredits(user.credits);
    } else {
      setCredits(0);
    }

    setRoleId(user.roleId);

    if (user.emails) {
      const options = [];
      const data = user.emails.split(",");
      for (let i = 0; i < data.length; i++) {
        options.push({
          value: data[i],
          label: data[i],
        });
      }
      setSelectedEmails(options);
    }

    if (user.phones) {
      const options = [];
      const data = user.phones.split(",");
      for (let i = 0; i < data.length; i++) {
        options.push({
          value: data[i],
          label: data[i],
        });
      }
      setSelectedPhones(options);
    }

    setVersion(user.version);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">
                  {id ? t("pages.titles.editUser") : t("pages.titles.createUser")}
                  {id === apiService.getId() ? t("common.labels.mePrefix") : ""}
                </Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Form.Group>
                    <label>{t("common.labels.username")}</label>
                    <Form.Control
                      placeholder={t("common.labels.username")}
                      type="text"
                      value={username}
                      onChange={(event) => setUsername(event.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group>
                    <label>{t("common.labels.fullName")}</label>
                    <Form.Control
                      placeholder={t("common.labels.fullName")}
                      type="text"
                      value={fullName}
                      onChange={(event) => setFullName(event.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  {!id || apiService.isSuperAdmin() || apiService.getId() === id ? (
                    <Form.Group>
                      <label>{t("common.labels.password")}{id && (apiService.isSuperAdmin() || apiService.getId() === id) ? t("common.labels.change") : null}</label>
                      <Form.Control
                        placeholder={t("common.labels.password")}
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  ) : null}
                  {!id || apiService.isSuperAdmin() || apiService.getId() === id ? (
                    <Form.Group>
                      <label>{t("common.actions.confirmPassword")}</label>
                      <Form.Control
                        placeholder={t("common.actions.confirmPassword")}
                        type="password"
                        value={passwordRepeat}
                        onChange={(event) => setPasswordRepeat(event.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  ) : null}

                  {apiService.getId() === id ? null : <RoleSelect defaultValue={roleId} handler={setRoleId} disabled={selectorDisabled} />}

                  <Form.Group>
                    <label>Emails</label>
                    {invalidEmail ? (
                      <div style={{ color: "crimson" }}>
                        {t("messages.the") + emailInput + t("messages.isNotAValidEmail")}
                      </div>
                    ) : null}
                    <Select
                      isMulti
                      components={{ DropdownIndicator: null }}
                      className="primary"
                      name="multiSelect"
                      value={selectedEmails}
                      inputValue={emailInput}
                      options={[]}
                      onChange={(selected, actionMeta) => {
                        if (actionMeta.action === "remove-value" || actionMeta.action === "pop-value") {
                          const removedOption = actionMeta.removedValue;
                          const updatedOptions = selectedEmails.filter((option) => option.value !== removedOption.value);
                          setSelectedEmails(updatedOptions);
                        }
                      }}
                      onInputChange={(value) => {
                        setInvalidEmail(false);
                        setEmailInput(value);
                      }}
                      onKeyDown={(event) => {
                        if (!emailInput) return;
                        if (!isValidEmail(emailInput)) {
                          setInvalidEmail(true);
                        } else {
                          switch (event.key) {
                            case "Enter":
                            case "Tab":
                              setSelectedEmails([
                                ...selectedEmails,
                                {
                                  value: emailInput,
                                  label: emailInput,
                                },
                              ]);
                              setEmailInput("");
                              event.preventDefault();
                          }
                        }
                      }}
                      placeholder={t("messages.type")}
                      noOptionsMessage={() => t(
                        "messages.toAddANewValueTypeItAndThenPressEnterOrTab",
                      )}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>{t("common.labels.phoneNumbers")}</label>
                    {invalidPhone ? (
                      <div style={{ color: "crimson" }}>
                        {t("messages.the") + phoneInput + t("messages.isNotAValidPhoneNumber")}
                      </div>
                    ) : null}
                    <Select
                      isMulti
                      components={{ DropdownIndicator: null }}
                      className="primary"
                      name="multiSelect"
                      value={selectedPhones}
                      inputValue={phoneInput}
                      options={[]}
                      onChange={(selected, actionMeta) => {
                        if (actionMeta.action === "remove-value" || actionMeta.action === "pop-value") {
                          const removedOption = actionMeta.removedValue;
                          const updatedOptions = selectedPhones.filter((option) => option.value !== removedOption.value);
                          setSelectedPhones(updatedOptions);
                        }
                      }}
                      onInputChange={(value) => {
                        setInvalidPhone(false);
                        if (isValidPhoneInput(value)) {
                          setPhoneInput(value);
                        }
                      }}
                      onKeyDown={(event) => {
                        if (!phoneInput) return;
                        if (!isValidPhone(phoneInput)) {
                          setInvalidPhone(true);
                        } else {
                          switch (event.key) {
                            case "Enter":
                            case "Tab":
                              setSelectedPhones([
                                ...selectedPhones,
                                {
                                  value: phoneInput,
                                  label: phoneInput,
                                },
                              ]);
                              setPhoneInput("");
                              event.preventDefault();
                          }
                        }
                      }}
                      noOptionsMessage={() =>
                        t("common.labels.toAddANewValueTypeSuffix") + t(
                          "messages.andThenPressEnterOrTabOnlyNumbersAndThePlusSignPlusAreAllowed",
                        )
                      }
                      placeholder={t("messages.type")}
                    />
                  </Form.Group>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default UserPage;
